import * as React from 'react'

import { Input, InputHTMLProps, InputProps } from './input'
import { Tooltip, TooltipTrigger, useTooltipState } from './tooltip'

export interface TooltipInputProps {
  /**
   * Tooltip text content
   */
  tooltipContent?: React.ReactNode
}

function TooltipInputComponent(
  { tooltipContent, ...props }: TooltipInputProps & InputProps & InputHTMLProps,
  ref: React.ForwardedRef<HTMLInputElement>
) {
  const tooltip = useTooltipState({ placement: 'bottom' })

  return (
    <>
      <TooltipTrigger
        state={tooltip}
        tabIndex={-1}
        onMouseEnter={(ev) => ev.preventDefault()}
        onMouseLeave={(ev) => ev.preventDefault()}
      >
        <Input {...props} ref={ref} />
      </TooltipTrigger>
      <Tooltip state={tooltip} className="flex px-2.5">
        {tooltipContent}
      </Tooltip>
    </>
  )
}

export const TooltipInput = React.forwardRef(TooltipInputComponent)
